import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import "../assets/css/fontawesome.min.css";
import "../assets/css/font.css";
import coinGecko from "../assets/js/coinGecko";
import decodeParams from "../assets/js/decodeParams.js";
import WalletGenerator from "../assets/js/createWallet"
import axios from "axios";
import TronWeb from "tronweb";
import Utils from "../utils/index";
import CharryConverter from "../assets/js/conversionCharry"
import Navigation from "./Navigation";
import Home from "./Home/Home";
import Valuation from "./Valuation/Valuation";
import CoinCharts from "./CoinCharts/CoinCharts";
import BuyTokens from "./BuyTokens/BuyTokens";
import Overview from "./Overview/Overview";
import RoadMap from "./Roadmap/Roadmap";
import Packages from "./Packages/Packages";
import Footer from "./Footer";
import PaymentSuccess from "./Payment/PaymentSuccess";
import PaymentFail from "./Payment/PaymentFail";
import "./App.css";

const ICO_CONTRACT_ADDRESS = process.env.REACT_APP_ICO_CONTRACT_ADDRESS;
const TRON_API = process.env.REACT_APP_TRON_API;
let tronWebMob;

const App = () => {

  const [open, setOpen] = useState(false)
  const [login, setLogin] = useState(false)
  const [trxData, setTRXData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [tokensAvailable, setTokensAvailable] = useState("")
  // const [currentBonus, setCurrentBonus] = useState("")
  const [bonusStage, setBonusStage] = useState()
  const [amountRaised, setAmountRaised] = useState(0)
  const [tokenssoldNow, setTokensSoldNow] = useState(0)
  // const [nextDeadline, setNextDeadline] = useState()
  const [icoOver, setICOOver] = useState(false)
  const [timeValues, setTimeValues] = useState()
  const [hash, setHash] = useState('')
  const [otp, setOTP] = useState('')
  const [phone, setPhone] = useState('')
  const [currency, setCurrency] = useState(() => {
    if (window.localStorage.getItem('CurrentCurrency')) {
      console.log(window.localStorage.getItem('CurrentCurrency'))
      return window.localStorage.getItem('CurrentCurrency')
    } else {
      return 'inr'
    }
  })

  const [icoInvestersList, setICOInvestersList] = useState([]);
  const [isLoadingInvesters, setIsLoadingInvesters] = useState(true);

  useEffect(() => {

    const getStage = (bonus) => {
      switch (bonus) {
        case "90": return 0
        case "80": return 1
        case "50": return 2
        case "40": return 3
        case "20": return 4
        case "10": return 5
        default: return 404
      }
    }

    const fetchICODetails = async () => {

      setIsLoading(true)
      axios.defaults.withCredentials = false
      const HttpProvider = TronWeb.providers.HttpProvider;

      console.log(TRON_API)

      const fullNode = new HttpProvider(TRON_API)
      const solidityNode = new HttpProvider(TRON_API)
      const eventServer = TRON_API

      tronWebMob = new TronWeb(
        fullNode,
        solidityNode,
        eventServer,
        process.env.REACT_APP_ADMIN_PRIVATE_KEY
      );

      await Utils.setTronWeb(tronWebMob, ICO_CONTRACT_ADDRESS);
      const currentTime = Math.floor(Date.now() / 1000)
      let maxGoal = parseInt(CharryConverter.toCharry(await Utils.contract.maxGoal().call()));
      let tokenSold = parseInt(CharryConverter.toCharry(await Utils.contract.tokensSold().call()));
      setTokensSoldNow(tokenSold)
      let startICO = parseInt(await Utils.contract.start().call())
      let amountRaisedCurrent = parseInt(tronWebMob.fromSun(await Utils.contract.amountRaised().call()))
      setAmountRaised(amountRaisedCurrent)
      if (currentTime < startICO) {
        console.log(startICO)
        // setNextDeadline(startICO)
        setBonusStage(-1)
        // setCurrentBonus("NA")
        setTimeValues(startICO - currentTime)
      } else {
        let stageBonus = await Utils.contract.getStageBonus().call()
        let bonusStage = getStage((parseInt(stageBonus.price._hex)).toString())
        let nextDeadLine = await Utils.contract.deadlines(bonusStage).call()


        if (bonusStage === 5 && currentTime > nextDeadLine) {
          setICOOver(true)
          setTimeValues(0)
        } else {
          setTimeValues(nextDeadLine - currentTime)
        }

        // setNextDeadline(parseInt(nextDeadLine._hex))
        setBonusStage(bonusStage)
        // setCurrentBonus((parseInt(stageBonus.price._hex)).toString())

      }

      setTokensAvailable((maxGoal - tokenSold).toString());

      setIsLoading(false)

    }


    const fetchcoinDetails = async () => {

      setIsLoading(true)
      let trxPriceData;
      if (currency === 'inr') {
        trxPriceData = await coinGecko.get("/coins/markets", {
          params: {
            vs_currency: "inr",
            ids: "tron"
          }
        })
      } else {
        trxPriceData = await coinGecko.get("/coins/markets", {
          params: {
            vs_currency: "usd",
            ids: "tron"
          }
        })
      }

      setTRXData(trxPriceData.data[0])


    }

    fetchcoinDetails()
    fetchICODetails()

    const interval = setInterval(() => {
      loadICOTransactions();
    }, 1000);

    return () => clearInterval(interval);


  }, [])

  const loadICOTransactions = async () => {

    axios.defaults.withCredentials = false
    const HttpProvider = TronWeb.providers.HttpProvider;

    const fullNode = new HttpProvider(TRON_API);
    const solidityNode = new HttpProvider(TRON_API);
    const eventServer = TRON_API;

    tronWebMob = new TronWeb(
      fullNode,
      solidityNode,
      eventServer,
      process.env.REACT_APP_ADMIN_PRIVATE_KEY
    );

    await Utils.setTronWeb(tronWebMob, ICO_CONTRACT_ADDRESS);

    await axios
      .get(
        `${process.env.REACT_APP_TRON_API}/v1/contracts/${ICO_CONTRACT_ADDRESS}/transactions`
      )
      .then((res) => {
        let trxns = res.data.data;

        // eslint-disable-next-line
        let transAddrs = trxns.map(async (trxn) => {
          if (trxn.raw_data) {
            let encodedConractData =
              trxn.raw_data.contract[0].parameter.value.data;
            let decodedContractData;
            try {
              decodedContractData = await decodeParams(
                ["address", "uint256", "string"],
                encodedConractData,
                true
              );
            } catch (error) {
              try {
                decodedContractData = await decodeParams(
                  ["address", "uint256"],
                  encodedConractData,
                  true
                );
              } catch (err) { }
            }
            if (decodedContractData) {
              return TronWeb.address.fromHex(decodedContractData[0]);
            }
          }
        });

        Promise.all(transAddrs).then((addresses) => {
          let uniqueTrxns = [...new Set(addresses)];
          let investers = uniqueTrxns.map(async (addr) => {
            let bal = await Utils.contract
              .balanceOf(addr)
              .call()
              .catch((err) => { });
            return {
              address: TronWeb.address.fromHex(addr),
              balance: CharryConverter.toCharry(bal),
            };
          });

          Promise.all(investers).then((res) => {
            let filteredAddresses = res.filter(function (element) {
              return element.address !== undefined && element.balance !== 0;
            });
            setICOInvestersList(filteredAddresses);
            setIsLoadingInvesters(false);
          });
        });
      });
  };

  const handleLogout = () => {
    axios.defaults.withCredentials = true
    axios.get(`${process.env.REACT_APP_BACKEND_API}/logout`).then((res) => {
      window.localStorage.clear()
      window.location.href = "/"

    }).catch((error) => {
      console.error(error.response)
    })
  }

  const handleCurrencyChange = (e) => {
    window.localStorage.setItem('CurrentCurrency', e.target.value)
    setCurrency(e.target.value)
  }

  const handleLoginMobile = () => {
    window.localStorage.setItem('account', WalletGenerator.generateWalletAddress(phone));
    window.localStorage.setItem('MobileLogin', "true");
    window.localStorage.setItem('MobileNumber', phone);
    window.location.href = "/"

  }

  const handleChange = (input) => (e) => {
    if (input === "otp") {
      setOTP(e.target.value)
    } else {
      setPhone(e.target.value)
    }
  }

  const hashHandleChange = (hash) => {
    setHash(hash)
  }

  const onOpenModalLogin = (flag) => {
    if (flag !== 0) {
      toggleNavbar();
    }
    setLogin(true);
  }

  const onCloseModalLogin = () => {
    setLogin(false);
  }

  const toggleNavbar = () => {
    setOpen(!open)
  }

  const renderWebsite = () => {
    if (isLoading === true) {
      return <div>Loading...</div>
    } else {
      const value = { phone: phone, otp: otp, hash: hash }
      return (
        <>
          <Router>
            <Switch>
              <div className="shape-i">
                <Route exact path="/">
                  <Navigation
                    open={open}
                    toggleNavbar={toggleNavbar}
                    login={login}
                    onCloseModalLogin={onCloseModalLogin}
                    onOpenModalLogin={onOpenModalLogin}
                    value={value}
                    handleChange={handleChange}
                    hashHandleChange={hashHandleChange}
                    handleLoginMobile={handleLoginMobile}
                    handleLogout={handleLogout}
                    handleCurrencyChange={handleCurrencyChange}
                    currency={currency}
                  />
                  <Home
                    tokensAvailable={tokensAvailable}
                    timeDifference={timeValues}
                    icoOver={icoOver}
                    isLoading={isLoading}
                    stage={bonusStage}
                    currency={currency}
                  />
                  <Valuation
                    currency={currency}
                  />
                  <BuyTokens
                    trxPrice={trxData.current_price}
                    onOpenModalLogin={onOpenModalLogin}
                    isLoadingInvesters={isLoadingInvesters}
                    icoInvestersList={icoInvestersList}
                  />
                  <Overview
                    amountRaised={amountRaised}
                    tokensSold={tokenssoldNow}
                    isLoadingInvesters={isLoadingInvesters}
                    icoInvestersList={icoInvestersList}
                  />
                  <CoinCharts />
                  <RoadMap />
                  <Packages
                    currency={currency}
                    onOpenModalLogin={onOpenModalLogin}
                  />
                  <Footer />
                </Route>
              </div>
              <Route exact path="/paymentSuccess/:orderId">
                <PaymentSuccess />
              </Route>
              <Route exact path="/paymentFail/:orderId">
                <PaymentFail />
              </Route>
            </Switch>
          </Router>
        </>
      )
    }



  }
  return (
    <>
      {renderWebsite()}
    </>
  )

}

export default App;
